module.exports = __webpack_public_path__ + "static/media/cikrle6.9b9d8d55.jpg";